import React from "react";
import { Users, User } from "lucide-react";

const SingleOrGroup = ({ onSelect }) => {
  return (
    <div className="min-h-screen confirm-single-group singleOrgroup bg-black/70 flex flex-col items-center justify-center text-white font-inter px-4 py-6">
      {/* Title */}
      <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-yellow-500 mb-6 sm:mb-8 tracking-wide text-center">
        Welcome to Ezulix Restaurant 🍽️
      </h1>

      {/* Subtitle */}
      <p className="text-base sm:text-lg md:text-xl text-gray-300 mb-8 sm:mb-12 text-center">
        Please select your dining preference
      </p>

      {/* Options */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-10 w-full sm:w-3/4 lg:w-2/3">
        {/* Single */}
        <div
          onClick={() => onSelect("single")}
          className="bg-gray-900 hover:bg-gray-800 cursor-pointer rounded-2xl shadow-lg p-6 sm:p-8 flex flex-col items-center justify-center transition-transform transform hover:scale-105"
        >
          <User size={50} className="text-green-400 mb-4 sm:mb-6" />
          <h2 className="text-xl sm:text-2xl font-semibold text-green-400 mb-2">
            Single
          </h2>
          <p className="text-gray-400 text-center text-sm sm:text-base">
            Perfect for individual guests who want to enjoy their meal alone.
          </p>
        </div>

        {/* Group */}
        <div
          onClick={() => onSelect("group")}
          className="bg-gray-900 hover:bg-gray-800 cursor-pointer rounded-2xl shadow-lg p-6 sm:p-8 flex flex-col items-center justify-center transition-transform transform hover:scale-105"
        >
          <Users size={50} className="text-blue-400 mb-4 sm:mb-6" />
          <h2 className="text-xl sm:text-2xl font-semibold text-blue-400 mb-2">
            Group
          </h2>
          <p className="text-gray-400 text-center text-sm sm:text-base">
            Ideal for friends, family, or team gatherings. Share the joy!
          </p>
        </div>
      </div>
    </div>
  );
};

export default SingleOrGroup;
